
import React, {} from 'react';
import SkillCard from '../../components/Cards/SkillCard';
import { skills } from './helper';
const Skills = (): JSX.Element =>  
(
        <div className='skills'>
            {skills.map((e, i) => <SkillCard key={i} category={e.category} skillset={e.skillset} />)}
            
        </div>
)

export default Skills;
